import { apiClient } from './client'

export interface ClientUsageTopClient {
  client: string
  calls: number
  errors: number
}

export interface ClientUsagePerUser {
  userId: number
  email: string | null
  clients: Array<{ client: string; calls: number }>
}

export interface ClientUsagePerTool {
  tool: string
  calls: number
  errors: number
}

export interface ClientUsageResponse {
  hours: number
  topClients: ClientUsageTopClient[]
  perUser: ClientUsagePerUser[]
  perTool: ClientUsagePerTool[]
}

export async function getClientUsage(
  userId?: number,
  orgId?: number,
  hours?: number
): Promise<ClientUsageResponse> {
  const params = new URLSearchParams()
  if (userId != null) params.set('userId', String(userId))
  if (orgId != null) params.set('orgId', String(orgId))
  if (hours != null) params.set('hours', String(hours))
  const qs = params.toString()
  return apiClient.get<ClientUsageResponse>(`/settings/client-usage${qs ? `?${qs}` : ''}`)
}

export interface AccessLogRow {
  client: string
  ip: string
  country: string | null
  region: string | null
  city: string | null
  userAgent: string
  path: string
  timestamp: string
}

export async function getAccessLogs(userId: number, limit?: number): Promise<AccessLogRow[]> {
  const params = new URLSearchParams({ userId: String(userId) })
  if (limit != null) params.set('limit', String(limit))
  return apiClient.get<AccessLogRow[]>(`/admin/access-logs?${params.toString()}`)
}
